import {
    defaultBaseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const leaveConfigurationAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'leaveConfigurationAPI',
    endpoints: (builder) => ({

        addLeaveConfiguration: builder.mutation({
            query: (data) => ({
                url: '/leave-master',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateLeaveConfiguration: builder.mutation({
            query: (data) => ({
                url: `/leave-master/${data?.leaveConfigurationId}`,
                method: 'PUT',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getListLeaveConfiguration: builder.query({
            query: ({ page = 0, size = 10, searchText = '', sortBy = '', sortDir = '' } = {}) => ({
                url: `/leave-master`,
                method: 'GET',
                params: { page, size, ...(searchText && { searchText }), ...(sortBy && { sortBy }), ...(sortDir && { sortDir }) }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getLeaveConfigById: builder.query({
            query: (leaveConfigurationId) => ({
                url: `/leave-master/${leaveConfigurationId}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllLeaveConfigDropdown: builder.query({
            query: () => ({
                url: `/dropdowns?pageName=APPLY_LEAVE_PAGE`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteLeaveConfiguration: builder.mutation({
            query: (leaveConfigurationId) => ({
                url: `/leave-master/${leaveConfigurationId}`,
                method: 'DELETE'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
});

export const {
    useAddLeaveConfigurationMutation, useUpdateLeaveConfigurationMutation,
    useLazyGetLeaveConfigByIdQuery,
    useLazyGetListLeaveConfigurationQuery, useLazyGetAllLeaveConfigDropdownQuery,
    useDeleteLeaveConfigurationMutation
} = leaveConfigurationAPI;

export default leaveConfigurationAPI;
